module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/logo-75149417525592c6e2064015daa28b9d.png";